import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import classNames from 'classnames'

interface FormattedI18nStringProps {
    i18nKey: string
    boldClassName?: string
}

export const FormattedI18nString: React.FC<FormattedI18nStringProps> = ({
    i18nKey,
    boldClassName,
}) => {
    const { t } = useTranslation('translations')

    const components = {
        b: <b className={classNames('font-semibold', boldClassName)} />,
        strong: (
            <strong className={classNames('font-semibold', boldClassName)} />
        ),
        p: <p />,
        a: <a />,
    }

    // Already-translated HTML (e.g. t('…') passed into Alert / toast) — parse as markup.
    // Catalog keys never contain '<'.
    if (i18nKey.includes('<')) {
        return <Trans t={t} defaults={i18nKey} components={components} />
    }

    return <Trans t={t} i18nKey={i18nKey} components={components} />
}
